var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLandrMini = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 38 30",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 28.2c7.29 0 13.2-5.91 13.2-13.2 0-7.29-5.91-13.2-13.2-13.2C7.71 1.8 1.8 7.71 1.8 15c0 7.29 5.91 13.2 13.2 13.2Zm0 1.8c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.5 28.2c7.29 0 13.2-5.91 13.2-13.2 0-7.29-5.91-13.2-13.2-13.2C15.21 1.8 9.3 7.71 9.3 15c0 7.29 5.91 13.2 13.2 13.2Zm0 1.8c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15Z"
})));
export default SvgLandrMini;